import { API_CALL } from '../../../middleware/api';

export const CHANGE_LAB_FEATURE_STATE = 'change-lab-feature-state';
export const GET_SESSION = 'get-session';
export const GET_SESSION_RESULT = `${GET_SESSION}/result`;

export const GET_LOGIN_HISTORY = 'get-login-history';
export const GET_LOGIN_HISTORY_RESULT = `${GET_LOGIN_HISTORY}/result`;

// 2FA Settings actions
export const GET_2FA_STATUS = 'get-2fa-status';
export const GET_2FA_STATUS_RESULT = `${GET_2FA_STATUS}/result`;
export const GET_2FA_STATUS_ERROR = `${GET_2FA_STATUS}/error`;

export const DISABLE_2FA = 'disable-2fa';
export const DISABLE_2FA_RESULT = `${DISABLE_2FA}/result`;
export const DISABLE_2FA_ERROR = `${DISABLE_2FA}/error`;

export const REGENERATE_2FA_CODES = 'regenerate-2fa-codes';
export const REGENERATE_2FA_CODES_RESULT = `${REGENERATE_2FA_CODES}/result`;
export const REGENERATE_2FA_CODES_ERROR = `${REGENERATE_2FA_CODES}/error`;

export const ENABLE_2FA_START = 'enable-2fa-start';
export const ENABLE_2FA_START_RESULT = `${ENABLE_2FA_START}/result`;
export const ENABLE_2FA_START_ERROR = `${ENABLE_2FA_START}/error`;

export const ENABLE_2FA_CONFIRM = 'enable-2fa-confirm';
export const ENABLE_2FA_CONFIRM_RESULT = `${ENABLE_2FA_CONFIRM}/result`;
export const ENABLE_2FA_CONFIRM_ERROR = `${ENABLE_2FA_CONFIRM}/error`;

export const UPDATE_PASSWORD = 'update-password';
export const UPDATE_PASSWORD_RESULT = `${UPDATE_PASSWORD}/result`;
export const UPDATE_PASSWORD_ERROR = `${UPDATE_PASSWORD}/error`;

// SAML Link actions
export const GET_SAML_LINK_STATUS = 'get-saml-link-status';
export const GET_SAML_LINK_STATUS_RESULT = `${GET_SAML_LINK_STATUS}/result`;
export const GET_SAML_LINK_STATUS_ERROR = `${GET_SAML_LINK_STATUS}/error`;

export const START_SAML_LINK = 'start-saml-link';
export const START_SAML_LINK_RESULT = `${START_SAML_LINK}/result`;
export const START_SAML_LINK_ERROR = `${START_SAML_LINK}/error`;

export const DELETE_SAML_LINK = 'delete-saml-link';
export const DELETE_SAML_LINK_RESULT = `${DELETE_SAML_LINK}/result`;
export const DELETE_SAML_LINK_ERROR = `${DELETE_SAML_LINK}/error`;

export const actions = {
  changeLabOption: feature => ({
    type: CHANGE_LAB_FEATURE_STATE,
    feature,
  }),

  getSessions: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/rails/api/users/session_info',
    },
    type: GET_SESSION,
  }),

  getLoginHistory: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/rails/api/users/login_history',
    },
    type: GET_LOGIN_HISTORY,
  }),

  get2FAStatus: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/auth/2fa/status',
    },
    type: GET_2FA_STATUS,
  }),

  disable2FA: (password) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/auth/2fa/disable',
      data: { password },
    },
    type: DISABLE_2FA,
  }),

  regenerate2FACodes: (password) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/auth/2fa/backup-codes',
      data: { password },
    },
    type: REGENERATE_2FA_CODES,
  }),

  enable2FAStart: (method = 'totp') => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/auth/2fa/setup',
      data: { method },
    },
    type: ENABLE_2FA_START,
  }),

  enable2FAConfirm: (code) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/auth/2fa/confirm',
      data: { code },
    },
    type: ENABLE_2FA_CONFIRM,
  }),

  updatePassword: (currentPassword, newPassword) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/auth/password',
      data: { current_password: currentPassword, new_password: newPassword },
    },
    type: UPDATE_PASSWORD,
  }),

  getSamlLinkStatus: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/saml/link',
    },
    type: GET_SAML_LINK_STATUS,
  }),

  startSamlLink: (currentPassword) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/v1/saml/link/start',
      data: { current_password: currentPassword },
    },
    type: START_SAML_LINK,
  }),

  deleteSamlLink: (currentPassword) => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: 'portal/v1/saml/link',
      data: { current_password: currentPassword },
    },
    type: DELETE_SAML_LINK,
  }),
};
